if (window._appSettings && window._appSettings.QuickLauncher) {
  //Khởi tạo element script
  let quickLauncher = document.createElement('script');
  let quickLauncherStyle = document.createElement('link');
  quickLauncher.setAttribute('src', window._appSettings.QuickLauncher.QuickLauncherUrl);
  quickLauncherStyle.setAttribute('href', window._appSettings.QuickLauncher.QuickLauncherUrlStyle);
  quickLauncherStyle.setAttribute('rel', 'stylesheet');
  document.head.appendChild(quickLauncher);
  document.head.appendChild(quickLauncherStyle);
}
